module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/headerless/headerless.component.css
// module id = ./src/app/examples/headerless/headerless.component.css
// module chunks = main